import { connect } from 'react-redux'
import MaintenanceFixCardsComponent from '../components/MaintenanceFixCardsComponent.jsx';
import {
    clean,
    forwardToFindFixableMCards,
    forwardToAssignFixingTarget,
    forwardToSortFixableMaintenanceCards,
    forwardToAssignPreprocedure,
    forwardToFindPhotosByCard,
    changePhotoListPreviousPage
} from '../actions';

const mapStateToProps = (state) => ({

    request: state.getIn(['maintenanceFixingReducer', 'request']),
    response: state.getIn(['maintenanceFixingReducer', 'response']),
    options: state.getIn(['maintenanceFixingReducer', 'options']),

    alert: state.getIn(['alertReducer', 'alert']),
})

const mapDispatchToProps = (dispatch) => ({
    findFixableMCards: (casePk) => {
        dispatch(forwardToFindFixableMCards(casePk));
        clean(dispatch);
    },
    assignFixingPant: (card) => {
        let editing = {
            card: card,
            type: "PANT"
        }
        dispatch(forwardToAssignFixingTarget(editing));
        clean(dispatch);
    },
    assignFixingClothes: (card) => {
        let editing = {
            card: card,
            type: "CLOTH"
        }
        dispatch(forwardToAssignFixingTarget(editing));
        clean(dispatch);
    },
    assignPreClothAction: (card, operator) => {
        dispatch(forwardToAssignPreprocedure(card, "CLOTH", operator));
        clean(dispatch);
    },
    assignPrePantAction: (card, operator) => {
        dispatch(forwardToAssignPreprocedure(card, "PANT", operator));
        clean(dispatch);
    },
    sortCards: (cards, order) => {
        dispatch(forwardToSortFixableMaintenanceCards(cards, order));
        clean(dispatch);
    },
    findPhotos: (cardId) => {
        dispatch(forwardToFindPhotosByCard(cardId));
    },
    changePhotoListPreviousPage: (previousPage) => {
        dispatch(changePhotoListPreviousPage(previousPage));
    }
})

const MaintenanceFixCardsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(MaintenanceFixCardsComponent)

export default MaintenanceFixCardsContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceFixCardsContainer.jsx